<template>
  <div class="niveau-personnel-wrap pt-20 pb-20">
    <div class="container mx-auto px-6">

      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
      Niveau Personnel
    </h2>

      <!-- Contenu principal -->
      <div class="content-text">
        <p class="mb-4">
          Au niveau personnel, il est possible de :
        </p>

        <ul class="list-disc ps-4">
          <li class="mb-2">
            Créer et favoriser en famille et dans son milieu professionnel ou d’activités 
            des espaces ou réseaux d’échange sur les questions de foi et de société ;
          </li>
          <li class="mb-2">
            Créer des équipes de travail ou militer dans des groupes ou mouvements 
            fonctionnels à l’école ;
          </li>
          <li class="mb-2">
            Soutenir l’œuvre de formation en suscitant des inscrits à l’école.
          </li>
        </ul>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NiveauPersonnelPage",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.niveau-personnel-wrap {
  background-color: #fff;
}

.content-text ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  line-height: 1.8;
}

h2 {
  color: #2b3a67;
}
</style>
